<template>
    <div class="main_content">
        <location-line />
        <common-data-table hover class="" :totalPage="totalPage" :curPage="curPage">
            <template slot="header">
                <b-thead>
                    <b-tr>
                        <b-th> ID </b-th>
                        <b-th> 이름 </b-th>
                        <b-th> IP </b-th>
                        <b-th> 구분 </b-th>
                        <b-th> 접속일시 </b-th>
                    </b-tr>
                </b-thead>
            </template>
            <template slot="body">
                <b-tbody>
                    <b-tr v-for="(item, index) in items" :key="index">
                        <b-td> {{ item.id }} </b-td>
                        <b-td> {{ item.name }} </b-td>
                        <b-td> {{ item.ip }} </b-td>
                        <b-td> {{ item.memo }} </b-td>
                        <b-td> {{ item.logdate }} </b-td>
                    </b-tr>
                </b-tbody>
            </template>
        </common-data-table>
    </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import LocationLine from '@/components/LocationLine'
import ax from '@/api/lbs'

export default {
    components: {
        commonDataTable,
        LocationLine
    },

    data() {
        return {
            curPage: parseInt(this.$route.query.page) || 1,
            totalPage: 1,
            items: []
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            ax.logList(this.curPage, (data) => {
                if (data) {
                    this.items = data.items
                    this.totalPage = data.totalPage
                } else {
                    this.items = []
                    this.totalPage = 1
                }
            })
        }
    },

    watch: {
        '$route.query': function () {
            this.curPage = parseInt(this.$route.query.page) || 1
            this.init()
        }
    }
}
</script>